import { Avatar, Box, Button, Flex, Image } from "@chakra-ui/react";
import { User } from "../../../../definitions/interfaces/Users/Users.interface";
import { ReactDispatchUserState } from "../../../../definitions/interfaces/Global/ReactDispatchStringState.type";
import { colors } from "../../../../definitions/constants/GlobalStyles";
import BodyText from "../../../Common/BodyText";
import { useEffect, useState } from "react";
import axios from "axios";
import { TShirtIcon } from "../../../../definitions/constants/IconsComponent";

const ItemPlayerTeamSquad = ({
  item,
  type,
  setUser,
  userActive,
}: {
  item: User;
  setUser?: ReactDispatchUserState;
  userActive?: User;
  type: string;
}): JSX.Element => {
  const [flag, setFlag] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const jsonLocation = JSON.parse(item.location_data);
        const responseFlag = await axios.get(
          `https://restcountries.com/v3.1/name/${jsonLocation.country}?fullText=true`
        );
        if (responseFlag.data) {
          setFlag(responseFlag.data[0]?.flags.svg);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [item]);

  return (
    <Button
      className="container-item-user"
      flexDirection="row"
      justifyContent="space-between"
    >
      <Box className="user-detail">
        <Avatar
          src={item.image_url}
          name={`${item.firstname} ${item.lastname}`}
        />
        <Flex direction="column">
          <BodyText
            fontSize={{ base: "12px", md: "14px" }}
            fontWeight="semiBold"
            textAlign="left"
            textColor={colors.text.black}
          >
            {item.firstname} {item.lastname}
          </BodyText>
          <Flex gap={1} alignItems={"center"}>
            <Image src={flag} height="14px" width="20px" />
            <BodyText
              fontSize={{ base: "11px", md: "12px" }}
              fontWeight="regular"
              textColor={colors.text.lightGray3}
            >
              {`@${item.firstname?.toLowerCase()?.trim()}${item.lastname
                ?.toLowerCase()
                ?.trim()}`.trim()}
            </BodyText>
          </Flex>
        </Flex>
      </Box>
      {type === "player" && item.number && (
        <Box
          background={colors.figmaColors.secColor}
          padding={"8px 10px"}
          borderRadius={"20px"}
          display={"flex"}
          gap={1}
        >
          <TShirtIcon
            style={{ stroke: "white", width: "16px", height: "16px" }}
          />
          <BodyText
            fontSize={{ base: "12px", md: "13px" }}
            fontWeight="bold"
            textColor={colors.text.white}
          >
            #{item.number}
          </BodyText>
        </Box>
      )}
    </Button>
  );
};
export default ItemPlayerTeamSquad;
